<div *ngIf="listItems.length > 0">
    <app-custom-item-order-list
        *ngFor="let item of listItems"
        [product]="item" 
     ></app-custom-item-order-list>
</div>
<div *ngIf="listItems.length == 0">
    <p>No hay detalle de una orden que mostrar en estos momentos.</p>
</div>